import moment from "moment";
import { useState, FormEvent, useEffect, useRef, ChangeEvent } from "react";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Modal, Button, Form, Table, TextArea, Popup, Select, Dropdown, List, Input, Checkbox } from "semantic-ui-react";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { TextField } from '@mui/material';
import { FilePlus, Trash } from 'phosphor-react';
import { toast } from 'react-toastify';
import "moment/locale/pt-br"

import { OsService } from "../../services/methods/OsService";

import { useSchedule } from "../../hooks/schedules";
import { useUser } from "../../hooks/user";

import { ISchedule } from "../../interfaces/ISchedule";

import { styleSheet } from "../../assets/styles/global";
import { getBase64 } from '../../utils/getBase64';

import {
  Schedules,
  TimeContainer,
  TimeTitle,
  Field,
  IntervalContainer,
  Title,
  // Select,
  OSDetail,
  OSDetailTitle,
  TableColumnText,
  TableDataText,
  ButtonTable,
  FieldContainer,
  Option,
  SelectContainer,
  TableContainer,
  InputWorkerHours,
} from './styles'
import { MondayService } from "../../services/methods/MondayService";
import { encode } from "base-64";

interface Props {
  visible: boolean;
  closeModal: () => void;
  data: ISchedule;
}

interface Breaks {
  start: string
  end: string
}

interface ITask {
  id: string;
  name: string;
  column_values: {
    text: string;
  }[]
}

interface IColumn {
  id: string;
  settings_str: {
    labels: string[]
    labels_colors: {
      color: string;
      border: string;
      var_name: string;
    }[]
  };
  title: string;
  type: string;
}

interface ISelectedTask {
  id: string;
  name: string;
  completed: boolean;
  workedHours: number;
  files: IFile[];
}

export interface IFile {
  fileName: string;
  fileData: string;
}

export const LaunchOSModal = ({ closeModal, data, visible }: Props) => {
  const osService: OsService = new OsService();
  const mondayService: MondayService = new MondayService();

  const inputRef = useRef<HTMLInputElement>({} as HTMLInputElement);

  const [hourWorkStart, setHourWorkStart] = useState(moment().hour(9).minute(0).toDate())
  const [hourWorkEnd, setHourWorkEnd] = useState(moment().hour(18).minute(0).toDate())
  const [hourLunchStart, setHourLunchStart] = useState(moment().hour(12).minute(0).toDate())
  const [hourLunchEnd, setHourLunchEnd] = useState(moment().hour(13).minute(0).toDate())
  const [intervalStart, setIntervalStart] = useState(moment().hour(0).minute(0).toDate())
  const [intervalEnd, setIntervalEnd] = useState(moment().hour(0).minute(0).toDate())
  const [breaks, setBreaks] = useState({ intervals: [{} as Breaks] })
  const [osDetail, setOsDetail] = useState('')
  const [justification, setJustification] = useState('')
  const [osData, setOsData] = useState<ISchedule>({} as ISchedule)
  const [isFirstInterval, setIsFirstInterval] = useState(true)
  const [totalIntervalMinutes, setTotalIntervalMinutes] = useState(0)
  const [selectedTaskId, setSelectedTaskId] = useState('SELECIONE')
  const [tasksArr, setTasksArr] = useState<ISelectedTask[]>([])
  const [columnsValues, setColumnsValues] = useState<{ title: string, value: string }[]>([])
  const [boardId, setBoardId] = useState('')

  const [fileList, setFileList] = useState<IFile[]>([]);

  const [tasks, setTasks] = useState<ITask[]>([])
  const [tasksColumns, setTasksColumns] = useState<IColumn[]>([])

  const {
    isLoading,
    setIsLoading,
    updateSchedulesData,
    setReceiveIsUpdate,
    analyst
  } = useSchedule()

  const { userInfo } = useUser();

  async function getTasks(osData: ISchedule) {
    try {
      setIsLoading(true)

      const { data, status } = await mondayService.tasks(osData.codcli, osData.codpro, encode(userInfo.emailEthosx.toLowerCase()))

      if (status === 200) {
        setTasks(data.data.boards[0].groups[0].items)
        setTasksColumns(data.data.boards[0].columns.map((column: any) => {
          const settings_str = JSON.parse(column.settings_str);
  
          if (!settings_str.labels || settings_str.hide_footer === false) {
            return {
              ...column,
              settings_str: {}
             }
          } else {
            return {
             ...column,
             settings_str: {
               labels: Object.values(settings_str.labels),
               labels_colors: Object.values(settings_str.labels_colors)
              }
            }
          }
        }))
        setBoardId(data.data.boards[0].id)
      } else {
        closeModal()
        return toast.error(data.data.message)
      }
    } catch (error: any) {
      if (error.response) {
        toast.error(error.response.data.errorMessage)
      }
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  async function updateTaskStatus(workedHours: number) {
    try {
      setIsLoading(true)
      const realHoursColumnIndex = tasksColumns.findIndex(column => column.title === 'Horas Real')
      
      for (const taskValue of tasksArr) {
        const totalWorkedHours = tasks.find(task => task.id === taskValue.id) ? Number(tasks.find(task => task.id === taskValue.id)!.column_values[realHoursColumnIndex].text || 0) + workedHours : workedHours
        const statusCompleted = taskValue.completed ? [{ title: 'Status', value: 'Concluido', }, { title: 'Detalhe', value: 'Entregue' }] : []
        const { data, status } = await mondayService.updateTasks(taskValue.id, boardId, [...statusCompleted,
          {
            title: 'Horas Real', value: totalWorkedHours
          }
        ])
  
        if (status === 200) {
          toast.success('Status Atualizado com sucesso')
        }
      }

    } catch (error: any) {
      if (error.response) {
        toast.error(error.response.data.errorMessage)
      }
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  async function updateTaskDescription(description: string) {
    try {
      setIsLoading(true)
      for (const taskValue of tasksArr) {
        const { data, status } = await mondayService.updateTasksDescription(taskValue.id, `${userInfo.emailEthosx} - ${description}`, fileList)

        if (status === 200) {
          toast.success('Descrição Atualizado com sucesso')
        }
      }
    } catch (error: any) {
      if (error.response) {
        toast.error(error.response.data.errorMessage)
      }
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  function createInputs() {
    if (isFirstInterval) return
    if (breaks.intervals.length > 0) {

      return (
        <TableContainer>
          <Title>Intervalos</Title>
          <Table celled compact  sortable selectable color='blue'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>
                  <TableColumnText>
                    Início
                  </TableColumnText>
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <TableColumnText>
                    Término
                  </TableColumnText>
                </Table.HeaderCell>
                <Table.HeaderCell width={1}>
                  <TableColumnText>
                    Opção
                  </TableColumnText>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {breaks.intervals.map((el, i) => (
                <Table.Row key={i}>
                  <Table.Cell><TableDataText>{el.start}</TableDataText></Table.Cell>
                  <Table.Cell><TableDataText>{el.end}</TableDataText></Table.Cell>
                  <Table.Cell width={1}>
                    <TableDataText>
                      <Popup
                        trigger={
                          <ButtonTable 
                            onClick={() => {
                              removeClick(i)
                            }}
                          >
                            <Trash size={20} color="#E47261" />
                          </ButtonTable>
                        }
                        content={<span style={{ fontSize: '1.3rem' }}>Excluir</span>}
                        inverted
                      />
                    </TableDataText>
                  </Table.Cell>
                </Table.Row>
              ))}

            </Table.Body>
          </Table>
        </TableContainer>
      )
    }
  }

  async function onFilesSelected(e: ChangeEvent<HTMLInputElement>, taskId: string) {
    e.preventDefault();
    const files = Array.prototype.slice.call(e.target.files)

    const filesSelected: IFile[] = [];
    for (const file of files) {
      const isFileUploaded = !!tasksArr.find(task => task.files.find(({ fileName }) => fileName === file.name));
      if (!isFileUploaded) {
        if (!!file) {
          const data = await getBase64(file)
          
          filesSelected.push({ fileName: file.name, fileData: data.toString() })
        }
      }
    }
    
    setTasksArr(prevState => prevState.map(prevTask => {
      if (prevTask.id === taskId) {
        return {
          ...prevTask,
          files: filesSelected
        }
      } else {
        return prevTask
      }
    }))

    setFileList([...fileList, ...filesSelected]);
  }


  function createTasks() {
    // if (isFirstInterval) return
    if (tasksArr.length > 0) {
      return (
        <TableContainer>
          <Title>Tarefas</Title>
          <Table celled sortable selectable color='blue'>
            <Table.Header>
              <Table.Row>
                  <Table.HeaderCell>
                    <TableColumnText>
                      Marcar como concluída
                    </TableColumnText>
                  </Table.HeaderCell> 
                  <Table.HeaderCell>
                    <TableColumnText>
                      Tarefa
                    </TableColumnText>
                  </Table.HeaderCell> 
                  <Table.HeaderCell>
                    <TableColumnText>
                      Horas trabalhadas
                    </TableColumnText>
                  </Table.HeaderCell> 
                  <Table.HeaderCell textAlign="center" width={1}>
                  <TableColumnText>
                    Docs
                  </TableColumnText>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {tasksArr.map((task, i) => (
                <Table.Row key={task.id}>

                  <Table.Cell textAlign="center" width={1}>
                      <Checkbox 
                        toggle 
                        checked={task.completed}
                        onChange={() => setTasksArr(prevState => prevState.map(prevTask => {
                          if (prevTask.id === task.id) {
                            return {
                              ...prevTask,
                              completed: !task.completed
                            }
                          } else {
                            return prevTask
                          }
                        }))}
                      />

                    </Table.Cell>
                  <Table.Cell><TableDataText>{task.name}</TableDataText></Table.Cell>
                  <Table.Cell textAlign="center" width={1}>
                      <InputWorkerHours 
                        type="number"
                        value={task.workedHours}
                        onFocus={e => e.target.select()}
                        max={24}
                        min={0}
                        onChange={(e) => setTasksArr(prevState => prevState.map(prevTask => {
                          if (prevTask.id === task.id) {
                            return {
                              ...prevTask,
                              workedHours: Number(e.target.value)
                            }
                          } else {
                            return prevTask
                          }
                        }))}
                      />
                  </Table.Cell>

                  <Table.Cell textAlign="center" width={1}>
                    <input 
                      ref={inputRef} 
                      style={{ display: 'none' }} 
                      type="file" 
                      multiple
                      onChange={(event) => onFilesSelected(event, task.id)}  
                    />
                    <Popup
                      trigger={
                        <ButtonTable 
                          onClick={() => { inputRef.current.click() }}
                        >
                          <FilePlus size={32} color={styleSheet.colorMain} />
                        </ButtonTable>
                      }
                      content={<span style={{ fontSize: '1.3rem' }}>Upload</span>}
                      inverted
                    />
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
          <Table celled sortable selectable color='blue'>
            <Table.Header>
              <Table.Row>
                {
                  tasksColumns.map(column => (
                    <Table.HeaderCell>
                      <TableColumnText>
                        {column.title}
                      </TableColumnText>
                    </Table.HeaderCell>
                  ))
                }
                 <Table.HeaderCell textAlign="center" width={1}>
                  <TableColumnText>
                    Docs
                  </TableColumnText>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {/* {tasksArr.map((task, i) => (
                <Table.Row key={task.id}>
                  {
                    tasksColumns.map((column, index) => {
                      if (column.settings_str.labels_colors) {
                        return (
                          <Table.Cell style={{ backgroundColor: column.settings_str.labels_colors ? column.settings_str.labels_colors[column.settings_str.labels.findIndex(color => color === task.column_values[index].text)]?.color : 'transparent' }}>
                            <Popup 
                              trigger={
                                <Button 
                                  fluid
                                  style={{ 
                                    backgroundColor: column.settings_str.labels_colors 
                                    ? column.settings_str.labels_colors[column.settings_str.labels.findIndex(color => color === task.column_values[index].text)]?.color 
                                    : 'transparent',
                                    color: styleSheet.shape,
                                    fontSize: '1.2rem'
                                 }}
                                >
                                  {task.column_values[index].text}
                                </Button>
                              } 
                              flowing 
                              hoverable
                            >
                              <List>
                                {
                                  column.settings_str.labels.map((status, indexLabels) => (
                                    <List.Item>
                                      <Button
                                        fluid
                                        size="big"
                                        onClick={(ev, data) => {
                                          if (columnsValues.find(item => item.title === column.title)) {
                                            setColumnsValues(prevState => [...prevState.filter(item => item.title !== column.title), { title: column.title, value: data.children!.toString() }])
                                          } else {
                                            setColumnsValues(prevState => [...prevState, { title: column.title, value: data.children!.toString() }])
                                          }
                                          setTasksArr(prevTasksColumns => [...prevTasksColumns.filter((_,taskIndex) => taskIndex !== i), {...task, column_values: task.column_values.map((task, columnValueIndex) => { if (columnValueIndex === index) { return {...task, text: data.children!.toString() } } else {
                                            return task
                                          } } )}])
                                        }} 
                                        style={{ backgroundColor: column.settings_str.labels_colors[indexLabels].color, color: '#FFF' }} 
                                      >
                                        {status}
                                      </Button>
                                    </List.Item>
                                  ))
                                }
                              </List>
                            </Popup>
                          </Table.Cell>
                        )
                      }else {
                        return (
                          <Table.Cell><TableDataText>{task.column_values[index].text}</TableDataText></Table.Cell>
                        )
                      }
                    })
                  }

                  <Table.Cell textAlign="center" width={1}>
                    <input 
                      ref={inputRef} 
                      style={{ display: 'none' }} 
                      type="file" 
                      multiple
                      onChange={onFilesSelected}  
                    />
                    <Popup
                      trigger={
                        <ButtonTable 
                          onClick={() => { inputRef.current.click() }}
                        >
                          <FilePlus size={32} color={styleSheet.colorMain} />
                        </ButtonTable>
                      }
                      content={<span style={{ fontSize: '1.3rem' }}>Upload</span>}
                      inverted
                    />
                  </Table.Cell>
              </Table.Row>
              ))} */}
            </Table.Body>
          </Table>
        </TableContainer>
      )
    }
  }

  const handleAddNewInterval = () => {
    if (String(intervalStart) === '' || String(intervalStart) === 'Invalid Date' || String(intervalStart) === 'Data inválida') {
      return toast.error('Selecione uma hora para começar o intervalo')
    }
    if (String(intervalEnd) === '' || String(intervalEnd) === 'Invalid Date' || String(intervalEnd) === 'Data inválida') {
      return toast.error('Selecione uma hora para terminar o intervalo')
    }

    if (moment(intervalStart).format('HH:mm') < moment(hourWorkStart).format('HH:mm')) {
      return toast.error('Intervalo fora do horarío de trabalho')
    }

    if (moment(intervalEnd).format('HH:mm') > moment(hourWorkEnd).format('HH:mm')) {
      return toast.error('Intervalo fora do horarío de trabalho')
    }

    if (isFirstInterval) {
      setBreaks({ intervals: [{ start: moment(intervalStart).format('HH:mm'), end: moment(intervalEnd).format('HH:mm') }] })
    } else {
      const intevalsRepeted = breaks.intervals.find(interval => (interval.start <= moment(intervalStart).format('HH:mm') && interval.end >= moment(intervalStart).format('HH:mm')) || (interval.start <= moment(intervalEnd).format('HH:mm') && interval.end >= moment(intervalEnd).format('HH:mm')))
      if (intevalsRepeted !== undefined) {
        return toast.error('Período de intervalo já adicionado')
      }

      setBreaks({ intervals: [...breaks.intervals, { start: moment(intervalStart).format('HH:mm'), end: moment(intervalEnd).format('HH:mm') }] })
    }
    setIsFirstInterval(false)
    const intervalMinutes = moment(intervalEnd).diff(moment(intervalStart), 'minutes')
    setTotalIntervalMinutes(totalIntervalMinutes + intervalMinutes)
    setIntervalStart(moment().hour(0).minute(0).toDate())
    setIntervalEnd(moment().hour(0).minute(0).toDate())
  }

  const removeClick = (index: number) => {
    let intervals = [...breaks.intervals];
    const start = moment().hour(Number(intervals[index].start.split(':')[0])).minute(Number(intervals[index].start.split(':')[1]))
    const end = moment().hour(Number(intervals[index].end.split(':')[0])).minute(Number(intervals[index].end.split(':')[1]))
    const intervalMinutes = moment(end).diff(moment(start), 'minutes')
    setTotalIntervalMinutes(totalIntervalMinutes - intervalMinutes)
    intervals.splice(index, 1);
    setBreaks({ intervals: intervals });
  }

  const handleAddNewTask = () => {
    if(selectedTaskId === 'SELECIONE') {
      return toast.error('Selecione uma tarefa!')
    }

    if(tasksArr.find(task => task.id  === selectedTaskId)) {
      return toast.error('Tarefa já selecionado por favor escolha outra!')
    }
    
    const selectedTask = tasks.find(task => task.id === selectedTaskId)!
    setTasksArr(prevState => [...prevState, { id: selectedTask.id, name: selectedTask.name, completed: false, files: [], workedHours: 0 }])
    setSelectedTaskId('SELECIONE')
  }

  const removeTasks = (id: string) => {
    let tasks = [...tasksArr];
    const tasksIndex = tasks.findIndex(task => task.id === id)
    tasks.splice(tasksIndex, 1);
    setTasksArr(tasks);
  }

  const handleOsLaunch = async (event: FormEvent) => {
    const token = await sessionStorage.getItem('token')
    const breaksArr: any = []
    let intervalMinutes = 0; 
    event.preventDefault()

    if(moment(osData.data).isAfter(moment())) {
      return toast.error('Você não pode lançar essa Os ainda.')
    }
    if (osDetail === '') {
      return toast.error('E necessário preencher o detalhe da OS.')
    }
    if(osDetail.length < 150) {
      return toast.error('O detalhe da OS precisa ter pelo menos 150 caracteres.')
    }
    if(moment(intervalStart).format('HH:mm') !== '00:00' && moment(intervalEnd).format('HH:mm') !== '00:00') {
      if (( String(intervalStart) !== '' || String(intervalStart) !== 'Invalid Date' || String(intervalStart) !== 'Data inválida') && (String(intervalEnd) !== '' || String(intervalEnd) !== 'Invalid Date' || String(intervalEnd) !== 'Data inválida')) {
        if (moment(intervalStart).format('HH:mm') < moment(hourWorkStart).format('HH:mm')) {
          return toast.error('Intervalo fora do horarío de trabalho')
        }
    
        if (moment(intervalEnd).format('HH:mm') > moment(hourWorkEnd).format('HH:mm')) {
          return toast.error('Intervalo fora do horarío de trabalho')
        }

        if (isFirstInterval) {
          breaksArr.push([
            Number(splitTime(moment(intervalStart).format('HH:mm'), true)),
            Number(splitTime(moment(intervalStart).format('HH:mm'), false)),
            Number(splitTime( moment(intervalEnd).format('HH:mm'), true)),
            Number(splitTime( moment(intervalEnd).format('HH:mm'), false)),
            "Intervalo",
          ])
        } else {
          const intevalsRepeted = breaks.intervals.find(interval => (interval.start <= moment(intervalStart).format('HH:mm') && interval.end >= moment(intervalStart).format('HH:mm')) || (interval.start <= moment(intervalEnd).format('HH:mm') && interval.end >= moment(intervalEnd).format('HH:mm')))
          if (intevalsRepeted !== undefined) {
            return toast.error('Período de intervalo já adicionado')
          }
          breaksArr.push([
            Number(splitTime(moment(intervalStart).format('HH:mm'), true)),
            Number(splitTime(moment(intervalStart).format('HH:mm'), false)),
            Number(splitTime( moment(intervalEnd).format('HH:mm'), true)),
            Number(splitTime( moment(intervalEnd).format('HH:mm'), false)),
            "Intervalo",
          ])
        }
        intervalMinutes = moment(intervalEnd).diff(moment(intervalStart), 'minutes')
      }
    } else if(moment(intervalStart).format('HH:mm') !== '00:00' && moment(intervalEnd).format('HH:mm') === '00:00') {
      return toast.error('Selecione uma hora de termino do seu intervalo.')
    }else if (moment(intervalStart).format('HH:mm') === '00:00' && moment(intervalEnd).format('HH:mm') !== '00:00') {
      return toast.error('Selecione uma hora de inicio do seu intervalo.')
    }

    if (String(hourWorkStart) === '' || String(hourWorkStart) === 'Invalid Date' || String(hourWorkStart) === 'Data inválida') {
      return toast.error('Selecione uma hora para começar o trabalho')
    }
    if (String(hourWorkEnd) === '' || String(hourWorkEnd) === 'Invalid Date' || String(hourWorkEnd) === 'Data inválida') {
      return toast.error('Selecione uma hora para terminar o trabalho')
    }

    if (String(hourLunchStart) === '' || String(hourLunchStart) === 'Invalid Date' || String(hourLunchStart) === 'Data inválida') {
      return toast.error('Selecione uma hora para começar o almoço')
    }
    if (String(hourLunchEnd) === '' || String(hourLunchEnd) === 'Invalid Date' || String(hourLunchEnd) === 'Data inválida') {
      return toast.error('Selecione uma hora para terminar o almoço')
    }


    function splitTime(time: string, isHour: boolean) {
      if (isHour) {
        return time.split(':')[0]
      } else {
        return time.split(':')[1]
      }
    }


    breaks.intervals.map(item => {
      breaksArr.push([
        Number(splitTime(item.start, true)),
        Number(splitTime(item.start, false)),
        Number(splitTime(item.end, true)),
        Number(splitTime(item.end, false)),
        "Intervalo",
      ])
      return item
    })
    const workedMinutes = moment(hourWorkEnd).diff(moment(hourWorkStart), 'minutes')
    if ((workedMinutes - totalIntervalMinutes - intervalMinutes) > 540 && justification === '') {
      return toast.error('Sua Os ultrapassou 9 horas, preencha uma justificativa.')
    }

    if ((tasksArr.reduce((prev, current) => prev += current.workedHours,0) * 60) > (workedMinutes - totalIntervalMinutes - intervalMinutes)) {
      return toast.error('Horas lançadas na tarefa ultrapassa as horas apontada na OS.')
    }

    try {
      setIsLoading(true)
      const tarefa = osDetail.replace(/\\/g, '/')
      const objectParams = {
        token,
        cliente: osData.codcli,
        projeto: osData.codpro,
        dataproj: moment(osData.data).format('DD/MM/YYYY'),
        tarefa: tarefa,
        projetohoras: [
          [
            Number(splitTime(moment(hourWorkStart).format('HH:mm'), true)),
            Number(splitTime(moment(hourWorkStart).format('HH:mm'), false)),
            Number(splitTime(moment(hourWorkEnd).format('HH:mm'), true)),
            Number(splitTime(moment(hourWorkEnd).format('HH:mm'), false)),
            "Total",
          ],
          [
            Number(splitTime(moment(hourLunchStart).format('HH:mm'), true)),
            Number(splitTime(moment(hourLunchStart).format('HH:mm'), false)),
            Number(splitTime(moment(hourLunchEnd).format('HH:mm'), true)),
            Number(splitTime(moment(hourLunchEnd).format('HH:mm'), false)),
            "Almoco",
          ],
          ...breaksArr
        ],
        local: osData.local,
        almoco: hourLunchStart === hourLunchEnd ? 'N' : 'S',
        justificativa: justification,
        analista: (userInfo.cargo === 'C' && analyst !== "") ? analyst : userInfo.codigo
      };

      closeModal()
      const { data, status: statusCode } = await osService.launchOs(objectParams)
      if (statusCode === 200 || statusCode === 201) {
        const { status, msg } = data
        if (status === 'ok') {
  
          toast.success(msg)
          setHourWorkStart(moment().hour(9).minute(0).toDate())
          setHourWorkEnd(moment().hour(18).minute(0).toDate())
          setHourLunchStart(moment().hour(12).minute(0).toDate())
          setHourLunchEnd(moment().hour(13).minute(0).toDate())
          setOsDetail('')
          const analista =  (userInfo.cargo === 'C' && analyst !== "") ? analyst : userInfo.codigo
          const { data } = await osService.getOs(osData.key, analista, token!)
          if (data.status === 'ok') {
            await Promise.all([
              updateTaskStatus((workedMinutes - totalIntervalMinutes - intervalMinutes) / 60),
              updateTaskDescription(tarefa),
              updateSchedulesData(data.analista)
            ])
          } else {
            toast.error('Ops... Algo deu errado tente novamente.')
            window.location.reload();
          }
          // loadSchedulesData(new Date().getMonth() + 1)
        } else {
          return toast.error(msg)
        }
      } else {
        return toast.error(data.errorMessage || "Ops, Algo deu errado.")
      }

    } catch (error: any) {
      if (error.response) {
        toast.error(error.response.data.errorMessage)
      }
      console.log(error)
    } finally {
      setIsLoading(false)
      setReceiveIsUpdate(false)
    }
  }

  useEffect(() => {
    setOsDetail(data.tarefa!)
    setJustification(data.justificativa ? data.justificativa.trim() : "")
    const projetoHoras = JSON.parse(data.projetohoras)
    const intervalArr: Breaks[] = []
    let start:moment.Moment;
    let end: moment.Moment;
    let intervalMinutes = 0;
    projetoHoras.map((item: any) => {
      if (item.includes('Total')) {
        setHourWorkStart(moment().hour(item[0]).minute(item[1]).toDate())
        setHourWorkEnd(moment().hour(item[2]).minute(item[3]).toDate())

      } else if (item.includes('Almoco')) {
        setHourLunchStart(moment().hour(item[0]).minute(item[1]).toDate())
        setHourLunchEnd(moment().hour(item[2]).minute(item[3]).toDate())

      } else {
        if (item.length > 0) {
          start = moment().hour(Number(item[0])).minute(Number(item[1]))
          end = moment().hour(Number(item[2])).minute(Number(item[3]))
          intervalMinutes += moment(end).diff(moment(start), 'minutes')
          intervalArr.push({ start: `${item[0] <= 9 ? '0' : ''}${item[0]}:${item[1] <= 9 ? '0' : ''}${item[1]}`, end: `${item[2] < 9 ? '0' : ''}${item[2]}:${item[3] < 9 ? '0' : ''}${item[3]}` })
          setIsFirstInterval(false)
        }
      }
      
      return item
    })
    setTotalIntervalMinutes(intervalMinutes)
    setBreaks({ intervals: intervalArr })
    setOsData(data)

    if (data.intMonday) {
      getTasks(data)
    }
    // eslint-disable-next-line
  }, [])
  
  return (
    <Modal
      open={visible}
      closeIcon
      onClose={closeModal}
      size="fullscreen"
      closeOnDimmerClick={false}
      style={{ fontFamily: styleSheet.mainFont }}
    >
      <Modal.Header>{data.nomecli} - {data.projeto} {moment(data.data).format('DD/MM/YYYY')}</Modal.Header>

      <Modal.Content scrolling style={{ width: '100%' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
          <Schedules>
            <LocalizationProvider dateAdapter={AdapterMoment} locale="pt-BR">
              <Form>
                <TimeContainer>
                  <TimeTitle>Horas trabalhadas</TimeTitle>
                  <FieldContainer>
                    <Field>
                      <TimePicker
                        label="Início"            
                        value={hourWorkStart}
                        shouldDisableTime={(timeValue: any, clockType: any) => {
                          if (clockType === 'minutes' && timeValue % 15) {
                            return true;
                          }
                          return false;
                        }}
                        onChange={(newValue: string | null) => {
                          setHourWorkStart(moment(newValue).toDate());
                        }}
                        renderInput={(params: any) => <TextField  {...params} />}
                      />
                    </Field>

                    <Field>
                      <TimePicker
                        label="Término"
                        value={hourWorkEnd}
                        shouldDisableTime={(timeValue: any, clockType: any) => {
                          if (clockType === 'minutes' && timeValue % 15) {
                            return true;
                          }

                          return false;
                        }}
                        onChange={(newValue: string | null) => {
                          setHourWorkEnd(moment(newValue).toDate());
                        }}
                        renderInput={(params: any) => <TextField  {...params} />}
                      />
                    </Field>
                  </FieldContainer>
                </TimeContainer>

                <TimeContainer>
                  <TimeTitle>Almoço</TimeTitle>
                  <FieldContainer>
                    <Field>
                      <TimePicker
                        label="Início"
                        value={hourLunchStart}
                        shouldDisableTime={(timeValue: any, clockType: any) => {
                          if (clockType === 'minutes' && timeValue % 15) {
                            return true;
                          }

                          return false;
                        }}
                        onChange={(newValue: string | null) => {
                          setHourLunchStart(moment(newValue).toDate());
                        }}
                        renderInput={(params: any) => <TextField  {...params} />}
                      />
                    </Field>

                    <Field>
                      <TimePicker
                        label="Término"
                        value={hourLunchEnd}
                        shouldDisableTime={(timeValue: any, clockType: any) => {
                          if (clockType === 'minutes' && timeValue % 15) {
                            return true;
                          }

                          return false;
                        }}
                        onChange={(newValue: string | null) => {
                          setHourLunchEnd(moment(newValue).toDate());
                        }}
                        renderInput={(params: any) => <TextField  {...params} />}
                      />
                    </Field>
                  </FieldContainer>
                </TimeContainer>

                <TimeContainer>
                  <TimeTitle>Intervalo</TimeTitle>
                  <FieldContainer>
                    <Field>
                      <TimePicker
                        label="Início"
                        value={intervalStart}
                        shouldDisableTime={(timeValue: any, clockType: any) => {
                          if (clockType === 'minutes' && timeValue % 15) {
                            return true;
                          }

                          return false;
                        }}
                        onChange={(newValue: string | null) => {
                          setIntervalStart(moment(newValue).toDate());
                        }}
                        renderInput={(params: any) => <TextField  {...params} />}
                      />
                    </Field>

                    <Field>
                      <TimePicker
                        label="Término"
                        value={intervalEnd}
                        shouldDisableTime={(timeValue: any, clockType: any) => {
                          if (clockType === 'minutes' && timeValue % 15) {
                            return true;
                          }

                          return false;
                        }}
                        onChange={(newValue: string | null) => {
                          setIntervalEnd(moment(newValue).toDate());
                        }}
                        renderInput={(params: any) => <TextField  {...params} />}
                      />
                    </Field>

                    <Field style={{ alignSelf: 'flex-end', position: 'absolute', right: '-55px' }}>
                      <Button 
                        size="huge" 
                        type="button" 
                        onClick={handleAddNewInterval}
                        icon="plus"
                        style={{ background: styleSheet.colorMain, color: styleSheet.shape }}
                      />
                    
                    </Field>
                  </FieldContainer>
                </TimeContainer>

                {
                  data.intMonday === "T" ? (
                    <TimeContainer>
                      <TimeTitle>Tarefa</TimeTitle>
                      <FieldContainer>
                        <Field style={{ flex: 1 }}>
                          <Dropdown 
                            style={{ padding: '12px' }}
                            value={selectedTaskId} 
                            placeholder='SELECIONE'
                            loading={isLoading}
                            fluid
                            selection
                            onChange={(e, data) => setSelectedTaskId(String(data.value))} 
                            options={tasks.map(task => { return {  key: task.id, value: task.id, text: task.name } })}
                          />
                            {/* <Option value="SELECIONE">SELECIONE</Option>
                            {
                              tasks.map(task => (
                                <Option value={task.id}>{task.name}</Option>
                              ))
                            }
                          </Select> */}
                        </Field>
                        <Field style={{ alignSelf: 'flex-end', position: 'absolute', right: '-55px' }}>
                          <Button 
                            size="huge" 
                            type="button" 
                            onClick={handleAddNewTask}
                            icon="plus"
                            style={{ background: styleSheet.colorMain, color: styleSheet.shape }}
                          />
                        </Field>
                      </FieldContainer>
                    </TimeContainer>
                  ) : null
                }
              </Form>
            </LocalizationProvider>
          </Schedules>

          
          <OSDetail>
              <OSDetailTitle>Detalhe da OS</OSDetailTitle>
              <TextArea
                style={{ width: '100%', height: '21rem', resize: 'none', padding: '1rem', fontSize: '1.6rem !important', borderRadius: '8px' }}
                value={osDetail.replaceAll('\\n', '\n')}
                onChange={
                  (ev, { value }) => { setOsDetail(String(value)) }
                }
              />
              {/* <Textarea rows={15} cols={30} maxLength={2300} value={osDetail.replaceAll('\\n', '\n')} onChange={e => setOsDetail(e.target.value)}></Textarea> */}
              <OSDetailTitle>Justificativa {(moment(hourWorkEnd).diff(moment(hourWorkStart), 'minutes') - totalIntervalMinutes - moment(intervalEnd).diff(moment(intervalStart), 'minutes')) > 540 ? '*' : ''}</OSDetailTitle>
              <TextArea
                style={{ width: '100%', height: '10rem', resize: 'none', padding: '1rem', fontSize: '1.6rem !important', borderRadius: '8px' }}
                value={justification.replaceAll('\\n', '\n')}
                onChange={
                  (ev, { value }) => { setJustification(String(value)) }
                }
              />
              {/* <JustificationInput rows={8} cols={30} value={justification.replaceAll('\\n', '\n')} onChange={e => setJustification(e.target.value)} /> */}
          </OSDetail>
        </div>

        {
          createTasks()
        }

        {
          createInputs()
        }
      </Modal.Content>

      <Modal.Actions>
        <Button.Group size='big'>
          <Button onClick={closeModal}>Cancelar</Button>
          <Button.Or text="ou" />
          <Button disabled={isLoading} onClick={handleOsLaunch} positive>Lançar</Button>
        </Button.Group>
      </Modal.Actions>
    </Modal>
  )
}
